// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wI x5","ribbon":"wJ yc","title":"wK x7","year":"wL x8","genres":"wM yb","duration":"wN","buttonWrapper":"wO x9","button":"wP x-","price":"wQ","upperParts":"wR"};